import React, {useState} from 'react'
import {RouteComponentProps} from "@reach/router";
import keyBy from "lodash/keyBy";
import template from "lodash/template";
import Secured from "../components/Secured";
import {getUser, logout} from "../_core/service";

require('./Home.css')


const pages = [
  {
    id: 'home',
    img: '/img/home.svg', 
    url: 'https://espace.fidelium.ma/extranet/news/index.php?dest=home&to=fidelnews&p1=home'
  },
  {
    id: 'catalog', 
    img: '/img/nav_geroto.png', 
    url: 'https://web2.carparts-cat.com/loginh.aspx?ssid=${catalogToken}'},
  {
    id: 'intranet',
    img: '/img/nav_intranet.png',
    url: 'https://espace.fidelium.ma/extranet/news/index.php?dest=intranet&to=../index&p1=home'
  },
  {
    id: 'academy',
    img: '/img/nav_academy.jpeg',
    url: 'https://espace.fidelium.ma/extranet/news/index.php?dest=campus&to=../eina&p1=campus'
  },
  {
    id: 'pannes',
    img: '/img/nav_data_pannes.jpeg',
    url: 'https://espace.fidelium.ma/extranet/news/index.php?dest=dpanne&to=../eina&p1=vts'
  }
]

const pageIds = keyBy(pages, 'id');
let initialPageId = 'home'
if (window.location.hash && pageIds[window.location.hash.substr(1)]) {
  initialPageId = window.location.hash.substr(1)
}


const Home = ({navigate}: RouteComponentProps) => {

  
  
  const [active, setActive] = useState(initialPageId)

  const user = getUser();

  const toggleNav = (id: string) => {
  
    if (id === active) {
      // force reload iframe
      const frame = document.querySelector('iframe');
      if (frame != null && frame.contentWindow != null) {
        try {
          frame.contentWindow.location.assign(pageIds[id].url);         
          console.log('iframe content reloaded')
        }catch (e) {
          console.warn('unable to reload iframe content', e)
        }
      }else {
        console.warn('unable to reload iframe content')
      }
    } else {
      window.location.hash = '#' + id;
      setActive(id)
    }
  }
  const handleLogout = async () => {
    await logout()
    if (navigate) {
      navigate("/", {})
    } else {
      window.location.href = '/'
    }
  }


  function handleIframeLoad(){
    const user = getUser();
    const frame = document.querySelector('iframe');
    
    frame!.contentWindow!.postMessage({action:"navigation",data:{
      userName: user?.name,
      customerId: user?.customerId,
      login: user?.username,
      catalogToken: user?.catalogToken,
      zone:user?.zone
    }},'*')
  }

  const url = template(pageIds[active].url)({
    userName: user?.name,
    customerId: user?.customerId,
    login: user?.username,
    catalogToken: user?.catalogToken,
    zone:user?.zone
  })

  return (
    <Secured>
      <div className="min-h-screen bg-gray-50 py-12 app-layout">
        <aside>
          <div className="ui-brand">
            <a href="/" title="Fidelium"><img src="/img/fidelium-symbol.png" alt=""/></a>
          </div>
          <div className="ui-main-nav">
            <nav>
              {pages.map(({id, img}) => (
                <a key={id} title="" className={active === id ? 'active' : ''} onClick={() => toggleNav(id)} href="#">
                  <img src={img} alt=""/>
                </a>
              ))}
            </nav>
          </div>
          <div className="ui-bottom-nav">
            <nav>
              <a onClick={handleLogout} href="#" title={""}><img src="/img/logout.svg" alt=""/></a>
            </nav>
          </div>
        </aside>
        <main>
          <iframe id="ifr-main" src={url} frameBorder="0" onLoad={handleIframeLoad}/>
        </main>
      </div>
    </Secured>
  )
}

export default Home
